import { patterns } from '../../../constants/patterns';
import { validationService } from '../../../services/validationService';

export const validateEmail = (value: string | undefined | null) =>
  !value || patterns.EMAIL.test(value) || 'Invalid email address';

export const validateExistEmail = async (email: string): Promise<true | string> => {
  try {
    await validationService.validateExistEmail(email);

    return true;
  } catch (error: any) {
    return error.response?.data?.message || 'Email already exists';
  }
};
